import { useForm, Controller } from "react-hook-form";
import BaseModal from "@/components/shared/modals/BaseModal";
import SelectInput from "@/components/shared/inputs/SelectInput";
import TextareaField from "@/components/shared/inputs/TextareaField";
import { useJobRequisitionStore } from "../store/useJobRequisitionStore";
import {  VIEW_CANDIDATE_MODAL_KEYS } from "../constant/constant";
import { ConfirmationModal } from "@/components/shared/modals/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import * as Icons from "@/assets/features/requistion";
import { REQUISITIONREASONS } from "@/constants/constants";
export default function RejectionReasonModal() {
  const { setActionModal, actionModal ,handleConfirmationClose} = useJobRequisitionStore();
  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      reasonType: "",
      reasonText: "",
    },
  });

  const reasonTypeValue = watch("reasonType");

 

  const onSubmit = (data) => {
    setActionModal(VIEW_CANDIDATE_MODAL_KEYS.REJECT_SUCCESS);
    reset();
  };

  return (
    <>
      <BaseModal
        open={actionModal === VIEW_CANDIDATE_MODAL_KEYS.REJECT}
        onClose={handleConfirmationClose}
        onConfirm={handleSubmit(onSubmit)}
        title="Rejection Reason"
        textBtn="Reject"
        variant="destructive"
        classNameBtn="bg-destructive-dark"
      >
        <div className="space-y-4 pt-4 pb-6">
          <Controller
            name="reasonType"
            control={control}
            rules={{ required: "Please select a rejection reason" }}
            render={({ field }) => (
              <SelectInput
                {...field}
                options={REQUISITIONREASONS}
                label="Rejection Reason"
                placeholder="Select rejection reason"
                className="w-full !h-[3rem] rounded-[1rem]"
                error={errors.reasonType?.message}
                required
              />
            )}
          />

          {reasonTypeValue === "other" && (
            <Controller
              name="reasonText"
              control={control}
              rules={{ required: "Please enter a reason" }}
              render={({ field }) => (
                <TextareaField
                  {...field}
                  label="Reason"
                  placeholder="Reason"
                  className="w-full !h-[8rem] rounded-[1rem]"
                  error={errors.reasonText?.message}
                  required
                />
              )}
            />
          )}
        </div>
      </BaseModal>
      <ConfirmationModal
        open={actionModal === VIEW_CANDIDATE_MODAL_KEYS.REJECT_SUCCESS}
        onOpenChange={handleConfirmationClose}
        icon={<Icons.Exclude className="h-18 w-18"/>}
        title="requisition rejected"
        confirmLabel="back to requisition history"
        classNameFooter={"!flex-col"}
        showCancel={false}
        onConfirm={() => {
          setActionModal(VIEW_CANDIDATE_MODAL_KEYS.NONE);

          navigate("/job-requisition/history");
        }}
      />
    </>
  );
}
